/* LumaSpec Learn on Shopify: reading progress, "On this page" highlight, section links, copy link, print, guides search.
   Ported from src/learn/assets/learn.js. Calculators: ls-learn-calc.js (loaded only where an article carries one).
   Search: the blog's own index view ({{ blog.url }}?view=ls-index, templates/blog.ls-index.liquid), fetched on the first
   keystroke so the hub stays light; matches every word in title + description. No result counts are shown. */
(function () {
  "use strict";
  /* Interface strings: snippets/ls-learn-i18n.liquid (locales ls.learn.js; placeholders {q} in single braces so Liquid's
     t filter leaves them for this script), English defaults otherwise. */
  var STR = {
    link_section: "Link to this section", link_copied: "Link copied", copy_prompt: "Copy this link",
    results: "Guides for “{q}”", empty: "Nothing found. Try fewer words, or ask our engineers."
  };
  try {
    var loc = JSON.parse((document.querySelector("[data-ls-learn-i18n]") || {}).textContent || "{}");
    for (var sk in loc) { if (Object.prototype.hasOwnProperty.call(loc, sk) && typeof loc[sk] === "string") { var d = document.createElement("textarea"); d.innerHTML = loc[sk]; STR[sk] = d.value; } }  /* the t filter HTML-escapes plain keys: plain text again (textContent / esc()) */
  } catch (e) { /* keep the defaults */ }
  var body = document.querySelector(".lx-body"), bar = document.querySelector(".lx-prog i");
  if (body && bar) {
    var ticking = false;
    var paint = function () {
      ticking = false;
      var r = body.getBoundingClientRect(), span = r.height - window.innerHeight * 0.6;
      var f = span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 1;
      bar.style.transform = "scaleX(" + f.toFixed(4) + ")";
    };
    window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }, { passive: true });
    paint();
  }

  var links = {}, heads = [];
  document.querySelectorAll(".lx-toc a[href^='#']").forEach(function (a) { links[a.getAttribute("href").slice(1)] = a; });
  if (body && "IntersectionObserver" in window) {
    body.querySelectorAll("h2[id],h3[id]").forEach(function (h) { if (links[h.id]) heads.push(h); });
    var current = null;
    var io = new IntersectionObserver(function () {
      var best = null;
      for (var i = 0; i < heads.length; i++) { if (heads[i].getBoundingClientRect().top < window.innerHeight * 0.35) best = heads[i]; }
      if (best && best !== current) {
        if (current && links[current.id]) links[current.id].classList.remove("on");
        links[best.id].classList.add("on");
        current = best;
      }
    }, { rootMargin: "0px 0px -60% 0px", threshold: [0, 1] });
    heads.forEach(function (h) { io.observe(h); });
  }

  if (body) body.querySelectorAll("h2[id],h3[id]").forEach(function (h) {
    var a = document.createElement("a");
    a.className = "lx-hash"; a.href = "#" + h.id; a.textContent = "#"; a.setAttribute("aria-label", STR.link_section);
    a.addEventListener("click", function () {
      var u = location.href.split("#")[0] + "#" + h.id;
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(u).catch(function () {});
    });
    h.appendChild(a);
  });
  document.querySelectorAll("[data-print]").forEach(function (b) {
    b.addEventListener("click", function () { document.querySelectorAll(".lx-faq details").forEach(function (d) { d.open = true; }); window.print(); });
  });
  document.querySelectorAll(".lx-tocm a").forEach(function (a) {
    a.addEventListener("click", function () { var d = a.closest("details"); if (d) d.open = false; });
  });
  document.querySelectorAll("[data-copy]").forEach(function (b) {
    b.addEventListener("click", function () {
      var t = b.getAttribute("data-copy"), done = function () { var o = b.textContent; b.textContent = STR.link_copied; setTimeout(function () { b.textContent = o; }, 1600); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t).then(done, function () { prompt(STR.copy_prompt, t); });
      else { prompt(STR.copy_prompt, t); }
    });
  });

  // guides search: {rows: [[url, title, description, topic tag, label, accent]], more} from the index view, newest first
  var find = document.querySelector("[data-lx-find]"), found = document.querySelector("[data-lx-found]");
  if (find && found) {
    var input = find.querySelector("input"), only = find.getAttribute("data-lx-find"), src = find.getAttribute("data-index"),
      base = find.getAttribute("data-base"), idx = null, loading = null, timer = 0;
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (ch) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[ch]; }); };
    var load = function () {  // every page of the index view (250 per page) until a short page
      if (loading) return loading;
      var rows = [];
      var page = function (n) {
        return fetch(src + (src.indexOf("?") < 0 ? "?" : "&") + "page=" + n, { credentials: "same-origin" })
          .then(function (r) { return r.json(); })
          .then(function (d) { rows = rows.concat(d.rows || []); return d.more && n < 40 ? page(n + 1) : rows; });
      };
      loading = page(1).then(function (r) { idx = r; return r; }, function () { idx = []; return idx; });
      return loading;
    };
    var show = function () {
      var q = input.value.toLowerCase().trim();
      if (!q) { found.hidden = true; found.innerHTML = ""; return; }
      var words = q.split(/\s+/), hits = idx.filter(function (r) {
        if (only && r[3] !== only) return false;
        var hay = (r[1] + " " + r[2]).toLowerCase();
        return words.every(function (w) { return hay.indexOf(w) >= 0; });
      });
      found.hidden = false;
      found.innerHTML = '<h2>' + esc(STR.results).replace("{q}", function () { return esc(input.value.trim()); }) + '</h2>' +
        (hits.length ? '<div class="lx-rcs">' + hits.slice(0, 24).map(function (r) {
          return '<a class="lx-rc" href="' + esc(r[0]) + '"' + (r[5] ? ' style="--acc:' + esc(r[5]) + '"' : "") +
            '><span class="lx-rc-k">' + esc(r[4]) + '</span><b>' + esc(r[1]) + '</b><span class="lx-rc-d">' + esc(r[2]) + "</span></a>";
        }).join("") + "</div>" : '<p class="lx-empty">' + esc(STR.empty) + '</p>');
    };
    input.addEventListener("focus", load, { once: true });
    input.addEventListener("input", function () {
      clearTimeout(timer);
      timer = setTimeout(function () { load().then(show); }, 120);
    });
  }
})();
